import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Layout from './components/Layout';
import VideoList from './components/VideoList';
import VideoPlayer from './components/VideoPlayer';
import { PeerTubeProvider } from './contexts/PeerTubeContext';
import { BucketProvider } from './contexts/BucketContext';
import AnswerBucket from './components/AnswerBucket';

// Create a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#00a278',
      dark: '#008e6a',
      light: '#4cd5b0',
    },
    secondary: {
      main: '#19857b',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body': {
          margin: 0,
          padding: 0,
          height: '100%',
          width: '100%',
          overflow: 'hidden',
        },
        '#root': {
          height: '100%',
          width: '100%',
          overflow: 'hidden',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PeerTubeProvider>
        <BucketProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<VideoList />} />
                <Route path="/video/:id" element={<VideoPlayer />} />
              </Routes>
              <AnswerBucket hideButton={true} />
            </Layout>
          </Router>
        </BucketProvider>
      </PeerTubeProvider>
    </ThemeProvider>
  );
}

export default App;
